var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 4.66699H9.33333M9.33333 4.66699C9.33333 5.63349 10.1168 6.41699 11.0833 6.41699C12.0498 6.41699 12.8333 5.63349 12.8333 4.66699C12.8333 3.70049 12.0498 2.91699 11.0833 2.91699C10.1168 2.91699 9.33333 3.70049 9.33333 4.66699ZM5.25 9.33366H11.6667M5.25 9.33366C5.25 10.3002 4.4665 11.0837 3.5 11.0837C2.5335 11.0837 1.75 10.3002 1.75 9.33366C1.75 8.36716 2.5335 7.58366 3.5 7.58366C4.4665 7.58366 5.25 8.36716 5.25 9.33366Z",
    stroke: "#1C80D2",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.481cdc4c14b9282f1bf6605cdd1ae0a5.svg";
export { ForwardRef as ReactComponent };